import React, { useId } from "react";
import cn from "classnames";
import { Icon } from "../../../Icon/Icon";
import Button from "../../../Button";
function Tag(props) {
    const id = useId();
    return (React.createElement("div", { className: cn("mr-2 flex max-w-full flex-shrink-0 items-center rounded-[5px] bg-main-color p-[4px_4px_4px_8px] text-on-main-color shadow-big", !props.onClose && "!px-4", props.className) },
        React.createElement("div", { id: id, className: "max-w-full overflow-hidden text-ellipsis whitespace-nowrap" }, props.children),
        props.onClose && (React.createElement(Button, { kind: "icon", "aria-description": `Remove Option`, ariaLabel: "", className: "ml-1 flex h-6 items-center justify-center", onClick: props.onClose, color: "white" },
            React.createElement(Icon, { className: "close-icon icon-[20px]" })))));
}
export default Tag;
//# sourceMappingURL=Tag.js.map